import React, { useState } from 'react';
import { connect } from 'react-redux';

import { Icon, IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { StringKeyValue } from '../../actions/types';
import { AppState } from '../../reducers';

interface Props {
    text: StringKeyValue;
}

const AboutCreditCard = (props: Props) => {
    const [expandPrivacy, setExpandPrivacy] = useState(false);
    const [expandTerms, setExpandTerms] = useState(false);
    const { text } = props;
    const {
        expandTermsTitle,
        expandTermsText1,
        expandTermsText2,
        expandTermsText3,
        expandTermsText4,
        expandTermsText5,
        expandTermsText6,
        expandTermsText7,
        expandTermsText7Url,
        expandTermsText8,
        expandPrivacyTitle,
        expandPrivacyText1,
        expandPrivacyText2,
        expandPrivacyText3,
        expandPrivacyText4,
        expandPrivacyText5,
        expandPrivacyText5Url,
        expandPrivacyText6,
    } = text;

    const termsData = (
        <div>
            {expandTermsText1 && <p>{expandTermsText1}</p>}
            {expandTermsText2 && <p>{expandTermsText2}</p>}
            {expandTermsText3 && <p>{expandTermsText3}</p>}
            {expandTermsText4 && <p>{expandTermsText4}</p>}
            {expandTermsText5 && <p>{expandTermsText5}</p>}
            {expandTermsText6 && <p>{expandTermsText6}</p>}
            {expandTermsText7 && (
                <p>
                    <Link href={expandTermsText7Url}>{expandTermsText7}</Link>
                </p>
            )}
            {expandTermsText8 && <p>{expandTermsText8}</p>}
        </div>
    );

    const privacyData = (
        <div>
            {expandPrivacyText1 && <p>{expandPrivacyText1}</p>}
            {expandPrivacyText2 && <p>{expandPrivacyText2}</p>}
            {expandPrivacyText3 && <p>{expandPrivacyText3}</p>}
            {expandPrivacyText4 && <p>{expandPrivacyText4}</p>}
            {expandPrivacyText5 && (
                <p>
                    <Link href={expandPrivacyText5Url}>{expandPrivacyText5}</Link>
                </p>
            )}
            {expandPrivacyText6 && <p>{expandPrivacyText6}</p>}
        </div>
    );

    return (
        <div className="about-credit-card">
            <div>
                <button className="expandable-item-button" type="button" onClick={() => setExpandTerms(!expandTerms)}>
                    {expandTermsTitle}
                    <Icon type={expandTerms ? IconTypes.LITEN_PIL_OPP : IconTypes.LITEN_PIL_NED} />
                </button>
            </div>
            {expandTerms && termsData}
            <div>
                <button
                    className="expandable-item-button"
                    type="button"
                    onClick={() => setExpandPrivacy(!expandPrivacy)}
                >
                    {expandPrivacyTitle}
                    <Icon type={expandPrivacy ? IconTypes.LITEN_PIL_OPP : IconTypes.LITEN_PIL_NED} />
                </button>
            </div>
            {expandPrivacy && privacyData}
        </div>
    );
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
});

export default connect(mapStateToProps)(AboutCreditCard);
